import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { SharedModule } from '../shared/shared.module';;
import { RouterModule } from '@angular/router';
import { MatIconModule, MatAutocompleteModule } from '@angular/material';
import { ExpandMenu } from './components/directive/expandmenu';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    SidebarComponent,
    TopbarComponent,
    ExpandMenu
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule
  ],
  exports: [
    SidebarComponent,
    TopbarComponent,
  ]
})
export class CoreModule { }
